import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../atoms/logo";
import { FiAlignJustify } from "react-icons/fi";
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { TbCaretDownFilled, TbCaretUpDown, TbCaretUpFilled } from "react-icons/tb";

interface SortButtonProps {
  title: string;
  sortState: string;
  sortList: string[];
  handleState: (sortState: string) => void;
}

const SortButton: React.FC<SortButtonProps> = ({ title, sortState, sortList, handleState }) => {
  return (
    <div
      className="flex justify-between w-full hover:cursor-pointer"
      onClick={() => {
        sortList.map((sort, idx) => {
          if (sortState === sort) {
            handleState(sortList[(idx + 1) % 3]);
          }
        });
        if (sortState === sortList[0] || (sortState !== sortList[1] && sortState !== sortList[2])) {
          handleState(sortList[1]);
        }
      }}
    >
      {title}
      {sortState === sortList[0] || (sortState !== sortList[1] && sortState !== sortList[2]) ? (
        <div className="">
          <TbCaretUpDown size={13} />
        </div>
      ) : (
        <></>
      )}
      {sortState === sortList[1] ? (
        <div className="flex items-start text-blue-500">
          <TbCaretUpFilled size={13} />
        </div>
      ) : (
        <></>
      )}
      {sortState === sortList[2] ? (
        <div className="flex items-end text-blue-500">
          <TbCaretDownFilled size={13} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SortButton;
